import consumer from "./consumer"

// Get game ID from meta tag or DOM
function getGameId() {
  const gameIdMeta = document.querySelector('meta[name="game-id"]');
  const gameIdElement = document.getElementById('game-id');
  
  return gameIdMeta ? gameIdMeta.getAttribute('content') : 
         gameIdElement ? gameIdElement.getAttribute('data-game-id') : null;
}

let gameChannelSubscription = null;

function initializeGameChannel() {
  const game_id = getGameId();
  
  if (!game_id) {
    console.log('No game ID found, skipping game channel subscription');
    return;
  }
  
  // Unsubscribe from existing channel if any
  if (gameChannelSubscription) {
    console.log('Unsubscribing from existing game channel');
    consumer.subscriptions.remove(gameChannelSubscription);
  }
  
  console.log(`Subscribing to game channel ${game_id}`);
  
  // Subscribe to game channel
  gameChannelSubscription = consumer.subscriptions.create({
    channel: "GameChannel", 
    game_id: game_id
  }, {
    connected() {
      console.log("Connected to game channel " + game_id);
      showConnectionStatus(true);
    },
    
    disconnected() {
      console.log("Disconnected from game channel " + game_id);
      showConnectionStatus(false);
    },
    
    received(data) {
      console.log("Game channel received:", data);
      handleGameUpdate(data);
    }
  });
}

function handleGameUpdate(data) {
  const { type, message, player_id } = data;
  
  switch(type) {
    case 'game_state_change':
      updateGameState(data);
      break;
    case 'player_connected':
      handlePlayerConnected(data);
      break;
    case 'player_disconnected':
      handlePlayerDisconnected(data);
      break;
    case 'player_turn_change':
      handleTurnChange(data);
      break;
    case 'card_played':
      handleCardPlayed(data);
      break;
    case 'game_finished':
      handleGameFinished(data);
      break;
    default:
      // Default behavior - update entire game state
      updateGameState();
  }
}

function updateGameState(data = null) {
  // Check if we have updategame function available
  if (typeof updategame === 'function') {
    updategame();
  } else if (typeof window.matatuGame !== 'undefined' && window.matatuGame.updateGame) {
    window.matatuGame.updateGame();
  } else {
    console.log('No update function available, refreshing page');
    window.location.reload();
  }
}

function handlePlayerConnected(data) {
  const { player_id } = data;
  console.log(`Player ${player_id} connected to game`);
  
  // Update game state to reflect new player
  updateGameState();
}

function handlePlayerDisconnected(data) {
  const { player_id } = data;
  console.log(`Player ${player_id} disconnected from game`);
  
  // Update game state
  updateGameState();
}

function handleTurnChange(data) {
  const { current_player_id, current_player_name } = data;
  
  // Check if it's our turn
  const playerIdMeta = document.querySelector('meta[name="player-id"]');
  const myPlayerId = playerIdMeta ? playerIdMeta.getAttribute('content') : null;
  
  if (current_player_id === myPlayerId) {
    showGameNotification("It's your turn!", 'success', 3000);
    // Optional: Play turn sound
    playTurnSound();
  } else {
    showGameNotification(`${current_player_name}'s turn`, 'info', 2000);
  }
  
  updateGameState();
}

function handleCardPlayed(data) {
  // No toast here: the board's status text already announces the play, and
  // the app clients' broadcast carries player_id/rank/suite (not the
  // player_name/card_rank/card_suit this handler once read), which made
  // this flash "undefined played undefined of undefined" on every
  // opponent move.
  updateGameState();
}

function handleGameFinished(data) {
  const { winner_name, message } = data;
  
  // Show game finished notification
  showGameNotification(message || `Game finished! Winner: ${winner_name}`, 'success', 5000);
  
  updateGameState();
}

function showGameNotification(message, type = 'info', duration = 3000) {
  // Create notification element specific to game updates
  const notification = document.createElement('div');
  notification.className = `game-notification game-notification--${type}`;
  notification.innerHTML = `
    <div class="game-notification-content">
      <span class="game-notification-message">${message}</span>
    </div>
  `;
  
  // Add to game area
  const gameArea = document.querySelector('.game-area') || document.body;
  gameArea.appendChild(notification);
  
  // Show with animation
  setTimeout(() => notification.classList.add('game-notification--show'), 10);
  
  // Remove after duration
  setTimeout(() => {
    notification.classList.remove('game-notification--show');
    setTimeout(() => notification.remove(), 300);
  }, duration);
}

function showConnectionStatus(connected) {
  // Show connection status indicator
  let statusIndicator = document.getElementById('connection-status');
  
  if (!statusIndicator) {
    statusIndicator = document.createElement('div');
    statusIndicator.id = 'connection-status';
    statusIndicator.className = 'connection-status';
    document.body.appendChild(statusIndicator);
  }
  
  if (connected) {
    statusIndicator.className = 'connection-status connection-status--connected';
    statusIndicator.textContent = window.I18n && window.I18n.translations ? window.I18n.translations.connected : 'Connected';

    // Hide after 2 seconds
    setTimeout(() => {
      statusIndicator.classList.add('connection-status--hidden');
    }, 2000);
  } else {
    statusIndicator.className = 'connection-status connection-status--disconnected';
    statusIndicator.textContent = window.I18n && window.I18n.translations ? window.I18n.translations.disconnected : 'Disconnected';
    statusIndicator.classList.remove('connection-status--hidden');
  }
}

function playTurnSound() {
  try {
    const audio = new Audio('/sounds/turn.mp3');
    audio.volume = 0.4;
    audio.play().catch(e => {
      console.log('Could not play turn sound:', e);
    });
  } catch (e) {
    console.log('Turn sound not available');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeGameChannel);

// Reinitialize on page navigation (for Turbolinks)
document.addEventListener('turbolinks:load', initializeGameChannel);

// Export for global access
window.initializeGameChannel = initializeGameChannel;




